import DataTable from "react-data-table-component";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
} from "chart.js/auto";
import {
  Chart,
  getDatasetAtEvent,
  getElementAtEvent,
  getElementsAtEvent,
} from "react-chartjs-2";

import { Doughnut } from "react-chartjs-2";
import { MouseEvent, useEffect, useRef, useState } from "react";
import { InteractionItem } from "chart.js";
// import { fetchData } from "../../../utils/services/api";
import "./Token.css";
import axios from "axios";
import { fetchCondo } from "../../../utils/services/api";
import Audio from "../../../common/Audio";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip
);

export const options = {
  scales: {
    y: {
      ticks: {
        color: "black",
        font: {
          size: 12,
        },
        stepSize: 14,
        min: 14,
        max: 140,
      },
    },
    x: {
      ticks: {
        color: "black",
        font: {
          size: 12,
        },
        stepSize: 1,
      },
    },
  },
};

const labels = [
  "Jan2023",
  "Feb2023",
  "March2023",
  "April2023",
  "May2023",
  "June2023",
  "July2023",
  "Aug2023",
  "Sept2023",
  "Oct2023",
  "Nov2023",
  "Dec2023",
  "Jan2024",
  "Feb2024",
  "March2024",
  "April2024",
  "May2024",
  "June2024",
  "July2024",
  "Aug2024",
  "Sept2024",
  "Oct2024",
];
const linedata = [
  101, 121, 111, 121, 126, 115, 107, 103, 107, 103, 102, 102, 99, 95, 97, 96,
  97, 96, 95, 94, 95, 118,
];
export const datas = {
  labels,
  datasets: [
    {
      type: "line",
      label: "Tokens Burnt Per Month",
      borderColor: "",
      borderWidth: 1,
      fill: false,
      data: linedata.map((item) => item),
    },
    {
      type: "bar",
      label: "Total Tokens Burnt",
      // backgroundColor: "#d86f44",
      backgroundColor: "#0087e0",
      data: linedata.map((item) => item),
      borderColor: "white",
      borderWidth: 1,
    },
  ],
};

const Token = () => {
  const [tokenData, setTokenData] = useState({});
  ChartJS.register(ArcElement, Tooltip, Legend);
  const data = {
    // labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
    datasets: [
      {
        label: "total supply",
        data: [tokenData.max_supply, tokenData.circulating_supply],
        backgroundColor: ["#0087e0", "rgb(255, 206, 153)"],
      },
    ],
  };

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetchCondo();
      setTokenData(res);
    };
    fetchData();
  }, []);

  const printDatasetAtEvent = (dataset) => {
    if (!dataset.length) return;

    const datasetIndex = dataset[0].datasetIndex;

    // console.log(data.datasets[datasetIndex].label);
  };

  const printElementAtEvent = (element) => {
    if (!element.length) return;

    const { datasetIndex, index } = element[0];

    // console.log(data.labels[index], data.datasets[datasetIndex].data[index]);
  };

  const printElementsAtEvent = (elements) => {
    if (!elements.length) return;

    // console.log(elements.length);
  };

  const chartRef = useRef(null);

  const onClick = (event) => {
    const { current: chart } = chartRef;

    if (!chart) {
      return;
    }

    printDatasetAtEvent(getDatasetAtEvent(chart, event));
    printElementAtEvent(getElementAtEvent(chart, event));
    printElementsAtEvent(getElementsAtEvent(chart, event));
  };
  return (
    <div className="">
      <div className="container mt-5">
        <div className="row">
          <div className="col-lg-4"></div>
          <div className="col-lg-4">
            <Doughnut data={data} />
            <br />
          </div>
          <div className="col-lg-4"></div>
          <div className="pie-info">
            {tokenData && (
              <div
                className="pie-heading"
                style={{
                  borderLeft: "5px solid #0087e0",
                  paddingLeft: "5px",
                }}
              >
                Total Supply : {tokenData.max_supply}
              </div>
            )}
            {tokenData && (
              <div
                className="pie-heading"
                style={{
                  borderLeft: "5px solid rgb(255, 206, 153)",
                  paddingLeft: "5px",
                }}
              >
                Circulating Supply :{" "}
                {tokenData.circulating_supply
                  ? tokenData.circulating_supply
                  : 0}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-2"></div>
          <div className="col-lg-8">
            <div className="treasuryBalances">
              <h3>Token Burns</h3>
              {/* <h6>A total of 37,492,945,732 BEAM tokens have been burnt</h6> */}
              <h6>A total of 0 tokens have been burnt</h6>
              <div className="treasurybalancechart">
                {/* <Bar options={options} data={data} />; */}
                <Chart
                  className="chart-data"
                  ref={chartRef}
                  type="bar"
                  onClick={onClick}
                  options={options}
                  data={datas}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-2"></div>
        </div>
      </div>
      <Audio />
    </div>
  );
};

export default Token;
